var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTortilla({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0126953,
    width: 40,
    height: 40,
    rx: 10,
    fill: "#E7EFFB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1338_2966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.75 24.8877H19.5938C19.35 24.8877 19.1875 24.8064 19.025 24.6439C18.8625 24.4814 18.7812 24.3189 18.7812 24.0752V21.6377C18.7812 21.4752 18.8625 21.2314 19.025 21.0689L23.8188 15.7877C24.225 15.3814 24.7125 15.1377 25.3625 15.1377C26.175 15.1377 26.9062 15.6252 27.2312 16.3564L30.6438 23.7502C30.725 23.9939 30.725 24.3189 30.5625 24.5627C30.3188 24.7252 29.9937 24.8877 29.75 24.8877Z",
    fill: "#F59D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4877 24.8877H10.8189C10.4939 24.8877 10.1689 24.7252 10.0877 24.4002C10.0064 24.0752 10.0064 23.7502 10.2502 23.5064L14.9627 18.3877C14.9627 18.3877 14.9627 18.3877 15.0439 18.3064C15.5314 17.8189 16.1002 17.5752 16.7502 17.5752C17.7252 17.5752 18.5377 18.1439 18.9439 18.9564L21.2189 23.6689C21.3002 23.9127 21.3002 24.2377 21.1377 24.4814C20.9752 24.7252 20.7314 24.8877 20.4877 24.8877Z",
    fill: "#F2C500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.625 24.0752L9.03125 27.8939C9.35625 30.8189 11.7938 33.0127 14.7188 33.0127H25.3625C28.2875 33.0127 30.725 30.8189 31.05 27.8939L31.4563 24.1564V24.0752H8.625Z",
    fill: "#8BBCEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1875 24.8877H7.8125C7.325 24.8877 7 24.5627 7 24.0752C7 23.5877 7.325 23.2627 7.8125 23.2627H32.1875C32.675 23.2627 33 23.5877 33 24.0752C33 24.5627 32.675 24.8877 32.1875 24.8877Z",
    fill: "#337DC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2812 16.7627C11.3062 16.7627 10.4125 16.0314 10.25 15.0564L9.4375 9.36895C9.4375 9.2877 9.4375 9.20645 9.4375 9.04395C9.4375 7.90645 10.3313 7.0127 11.4688 7.0127H11.875L20 8.6377C20.975 8.8002 21.625 9.69395 21.625 10.6689C21.625 11.4002 21.2188 12.0502 20.5688 12.4564L13.2562 16.5189C12.9312 16.6814 12.6063 16.7627 12.2812 16.7627Z",
    fill: "#F2C500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1338_2966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(7 7.0127)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTortilla);
export default __webpack_public_path__ + "static/media/tortilla.cc67e4c957535aec94b3ad1fec47fa91.svg";
export { ForwardRef as ReactComponent };